import mapResponseErrors from '@/common/mapResponseErrors'

export const catchFormError = (form, toast, message = 'Произошла ошибка') => (error) => {
  if (error?.response?.status === 422) {
    form.errors = mapResponseErrors(error.response)
  } else {
    toast.error(message)
  }
}